import { createFileRoute } from "@tanstack/react-router";
import { MemberRequestsPage } from "@/features/member-approval/pages/member-requests-page";
import { memberDeskSearchSchema } from "@/features/member-approval/schemas";
import { fetchMemberDesk, memberDeskQueryKey } from "@/features/member-approval/queries";

export const Route = createFileRoute("/_authed/tenants/$slug/access-governance/membership")({
  validateSearch: memberDeskSearchSchema,
  loaderDeps: ({ search }) => ({ search }),
  loader: ({ context, deps }) => {
    if (!context.authority.permissions.includes("organizations.write")) return;
    return context.queryClient.ensureQueryData({
      queryKey: memberDeskQueryKey(context.tenant.id, deps.search),
      queryFn: () => fetchMemberDesk(context.tenant.id, deps.search),
    });
  },
  component: MemberRequestsPage,
});
